import CurrencyManagement from './index';




export default {
  path: '/home/currencyManagement',
  component: CurrencyManagement,
  redirect: '/home/currencyManagement/scream',
  
};
